import React from 'react';
import { useTranslation } from 'react-i18next';

import { MemberAccessFlow, MemberAccessFlowResponse } from 'src/modules/auth/models/auth';
import { navigationService } from 'src/config/rootService';
import { AccessFlowForm } from './AccessFlowForm';

export type UserBasicData = {
    firstName?: string;
    lastName?: string;
    birthDate?: string;
    companyCode?: string;
};

export const RegisterForm: React.FC = () => {
    const { t } = useTranslation();

    const handleFetch = (
        accessFlowResponse: MemberAccessFlowResponse,
        email: string,
        userData: UserBasicData,
    ) => {
        const { accessFlow, ssoUrl } = accessFlowResponse;

        if (accessFlow === MemberAccessFlow.SSO && ssoUrl) {
            window.location.replace(ssoUrl);
        } else {
            navigationService.navigate('/registration-basics', { ...userData, email });
        }
    };

    return (
        <AccessFlowForm
            onFetch={handleFetch}
            title={t('auth:register_form.title')}
            subtitle={t('auth:register_form.subtitle')}
        />
    );
};
